import styled, { css } from 'styled-components'

export const Container = styled.div`
  ${css`
    width: 100%;

    > form > div > label,
    small {
      margin: 0;
    }

    > form > div > div {
      margin: 0.5rem 0 0.5rem 0;
    }
  `}
`

export const WrapperAlert = styled.div`
  margin-bottom: 0.5rem;
`

// The base Modal centers its children and sizes them to content
// (S.Content in components/Modal/styles.js is a flex column with
// align-items: center) — without width: 100% this shrink-wraps to the
// widest row's intrinsic content width instead of filling the available
// space, which is what was cutting the row dividers short.
export const Summary = styled.dl`
  width: 100%;
  margin: 1.5rem 0 0;
`

export const SummaryRow = styled.div`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: 12rem 1fr;
    gap: 1.5rem;
    padding: 1.25rem 0;
    border-bottom: 1px solid ${theme.colors.tertiary};

    &:first-child {
      padding-top: 0;
    }
  `}
`

export const SummaryLabel = styled.dt`
  ${({ theme }) => css`
    font-family: ${theme.font.family};
    font-weight: 500;
    font-style: normal;
    font-size: 0.875rem;
    line-height: 1.25rem;
    letter-spacing: -0.01em;
    vertical-align: middle;
    color: #000;
  `}
`

export const SummaryValue = styled.dd`
  ${({ theme }) => css`
    margin: 0;
    font-family: ${theme.font.family};
    font-weight: 400;
    font-style: normal;
    font-size: 0.875rem;
    line-height: 1.25rem;
    letter-spacing: -0.01em;
    vertical-align: middle;
    color: #707070;

    p {
      margin: 0;
    }
  `}
`

export const NoDestinationUrl = styled.span`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 0.75rem;

  .wrapperIconCircle svg {
    width: 0.75rem;
    height: 0.75rem;
  }
`

export const NoDestinationUrlCopy = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
`

interface Props {
  hasCancelButton: boolean
}
// The base Modal's box has one uniform padding (theme.spacings.xxxlarge)
// around title + content together, so a border-top drawn in the normal
// flow only spans that already-inset content width. Canceling it with a
// matching negative margin (left/right/bottom) lets this footer act as its
// own box: the divider sits on its outer edge and spans the full modal
// width, while its own padding re-creates the same inset for the buttons.
export const WrapperButtons = styled.div<Props>`
  ${({ theme, hasCancelButton }) => css`
    display: flex;
    justify-content: ${hasCancelButton ? 'flex-end' : 'flex-start'};
    gap: 0.8rem;
    margin: 1.5rem calc(-1 * ${theme.spacings.xxxlarge})
      calc(-1 * ${theme.spacings.xxxlarge});
    padding: 1rem ${theme.spacings.xxxlarge};
    border-top: 1px solid ${theme.colors.tertiary};
  `}
`
